import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { AppUser } from '../types/user';

export interface UserContextType {
  user: AppUser | null;
  loading: boolean;
  error: string | null;
}

export const UserContext = createContext<UserContextType>({
  user: null,
  loading: true,
  error: null,
});

export function useUserContext() {
  return useContext(UserContext);
}

export function UserProvider({ children, value }: { children: ReactNode; value: UserContextType }) {
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}
